import {
    RESTRICT_ACCESS_ENABLED,
    RESTRICT_ACCESS_FILTERS,
} from '../../../../../../../../../../modules/passport-pages/config';
import { DefaultPageViewModel } from '../../../default-page.viewmodel';

export const useRestrictAccess = (pageVm: DefaultPageViewModel) => {
    const {
        value: restrictAccess,
        touched: restrictAccessTouched
    } = pageVm.getFieldByKey(RESTRICT_ACCESS_ENABLED);

    const handleToggleRestrictAccess = () => {
        pageVm.setFieldValueByKey(RESTRICT_ACCESS_ENABLED, !restrictAccess);
        if (restrictAccess) {
            pageVm.setFieldValueByKey(RESTRICT_ACCESS_FILTERS, []);
        }
        if (!restrictAccessTouched) {
            pageVm.setValueTouched(RESTRICT_ACCESS_ENABLED);
        }
    };

    return {
        restrictAccess: restrictAccess as boolean,
        handleToggleRestrictAccess: handleToggleRestrictAccess,
    };
};